"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionType = void 0;
var ActionType;
(function (ActionType) {
    ActionType["SetTimezone"] = "set_timezone";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
;
